module.exports = __webpack_public_path__ + "img/card-error.b4568fbe.svg";